import Backbone from 'backbone';

export default Backbone.Model.extend({

    defaults: {
        elementCount: 0,
        currentOffset: 0,
        elementSize: 0,
        maxElements: 5,
        minOffset: 0,
        maxOffset: 0,
        touchStartMainAxis: 0,
        touchStartAuxilaryAxis: 0,
        touchStartOffset: 0,
        touchCurrentMainAxis: 0,
        touchCurrentAuxilaryAxis: 0
    },

    directions: {
        forward: 1,
        backward: -1
    },

    updateMaxOffset: function () {
        this.set({
            maxOffset: -1 * (this.get('elementCount') - this.get('maxElements')) * this.get('elementSize') + this.get('minOffset')
        });
    },

    move: function (direction) {
        var visibleItemsSize = this.get('elementSize') * this.get('maxElements');
        var directionModifier1;
        var directionModifier2;
        var currentSet;
        var newOffset;

        if (direction === this.directions.forward) {
            directionModifier1 = 0;
            directionModifier2 = 1;
        } else {
            directionModifier1 = 10;
            directionModifier2 = 0;
        }

        // count in which set of items we are
        currentSet = Math.floor(Math.abs((this.get('currentOffset') - this.get('minOffset') + directionModifier1) / visibleItemsSize));

        newOffset = (-visibleItemsSize * (currentSet + directionModifier2)) + this.get('minOffset');

        this.set('currentOffset', this.capOffset(newOffset));
    },

    capOffset: function (value) {
        var result = value;

        /*
         Cap to max offset
         */
        if (result < this.get('maxOffset')) {
            result = this.get('maxOffset');
        }

        /*
         Cap to min offset
         */
        if (result > this.get('minOffset')) {
            result = this.get('minOffset');
        }

        return result;
    },

    updateOffsetFromDelta: function (delta) {
        this.set('currentOffset', this.capOffset(this.get('touchStartOffset') - delta));
    },

    isControlForwardVisible: function () {

        if (this.get('elementCount') <= this.get('maxElements')) {
            return false;
        }

        return this.get('currentOffset') > this.get('maxOffset');
    },

    isControlBackwardVisible: function () {

        if (this.get('elementCount') <= this.get('maxElements')) {
            return false;
        }

        return this.get('currentOffset') < this.get('minOffset');
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/SliderModel.js
 **/